<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <ServiceDetail slot-scope="{data}" :form-data="data"></ServiceDetail>
  </l-cache>
</template>
<script>
  import ServiceDetail from "./serviceDetail";
  export default {
    name: 'iotServiceDetailBox',
    components: {ServiceDetail},
    methods: {
      async getItem (key) {
        let {items} = await this.$store.dispatch('iot/getServiceList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: this.$route.query.id}})
        return items[0]
      }
    }
  }
</script>
